import { render, staticRenderFns } from "./certificates-table.vue?vue&type=template&id=467d473d&"
import script from "./certificates-table.vue?vue&type=script&lang=js&"
export * from "./certificates-table.vue?vue&type=script&lang=js&"
import style0 from "./certificates-table.vue?vue&type=style&index=0&id=467d473d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports